export const thuongHieu = {
  sections: {
    list: { title: 'Brands' },
    detail: { title: 'Brand' },
  },
  titles: { add: 'Add brand', edit: 'Edit brand', create: 'Create brand' },
  columns: {
    code: 'Code',
    summary: 'Brand name',
    note: 'Note',
    status: 'Status',
    logo: 'Logo',
    soHangHoa: 'Products',
    nguoiTao: 'Created by',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    onOffAction: 'On/Off',
  },
  filter: {
    searchPlaceholder: 'Search by code or name...',
    textDetailTitle: 'Detail filters',
    sortSection: 'Sort',
    sortField: 'Sort by',
    sortDir: 'Sort direction',
  },
  filters: {
    hintSection: 'Hint',
    hintBody: 'Brand catalog used on products.',
    statusAll: 'All',
    brandTreeSection: 'Brand',
    treeAll: 'All brands',
    treeSearch: 'Search brands',
  },
  sort: {
    ngayTao: 'Created at',
    maThuongHieu: 'Brand code',
    tenThuongHieu: 'Brand name',
  },
  status: {
    dangHoatDong: 'Active',
    ngungHoatDong: 'Inactive',
  },
  actions: {
    pause: 'Deactivate',
    activate: 'Activate',
  },
  messages: {
    loadError: 'Could not load brands.',
    deleteSuccess: 'Brand deleted.',
    noData: 'No brands.',
    listSummary: '{count} item(s)',
    saveSuccess: 'Brand saved.',
    statusChanged: 'Status updated.',
    createSuccess: 'Brand created',
    selectedCount: '{count} selected',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm: 'Delete {count} selected brand(s)?',
    bulkDeleteSuccess: 'Deleted {count} brand(s)',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} could not be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No brands selected to delete',
    hhCount: '{count} item(s)',
  },
  form: {
    tenThuongHieu: 'Brand name',
    maThuongHieu: 'Brand code',
    ghiChu: 'Note',
    logoHint: 'Max 5MB. Format png/jpg/jpeg. You can also drag and drop an image.',
    logoChoose: 'Choose logo',
    logoPaste: 'Paste logo',
    logoPasteHint: 'Drag and drop an image, paste from clipboard, or use an http(s) link.',
    logoDragDrop: 'Drop image here',
  },
  validation: {
    tenRequired: 'Brand name is required.',
    maSaiDinhDang: 'Code must follow {prefix}xxx (e.g. {prefix}001).',
  },
  import: {
    description:
      'Excel file has 3 columns: Brand code (optional, format TH{project code}-xxx, unique across the system), Brand name (required), Note (optional). Empty code will be auto-generated.',
    success: 'Brands imported from Excel.',
    failed: 'Brand import from Excel failed.',
  },
  placeholders: {
    formTitle: 'Brand',
    formBody: '',
    tenThuongHieu: 'Enter brand name',
    maThuongHieu: 'Leave empty to auto-generate TH{project code}-001. Code must be unique across the system.',
    maThuongHieuTheoDuAn: 'Leave empty to auto-generate, or enter {prefix}001',
  },
}
